// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"80c2e1fa","832":"200b5307"}[chunkId] + ".chunk.js";
};